import { render } from "./DescendantTree.vue?vue&type=template&id=f5d64f00&scoped=true"
import script from "./DescendantTree.vue?vue&type=script&lang=js"
export * from "./DescendantTree.vue?vue&type=script&lang=js"

import "./DescendantTree.vue?vue&type=style&index=0&id=f5d64f00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5d64f00"]])

export default __exports__